import type { TCoreOptions } from '@libs/types';

/**
 * The active package's core options, injected by the app build (DefinePlugin, see `libs/core/build/resolveCoreOptions.js`):
 * the package's `core-options.json` with the stand's env overrides on top. Undefined outside an app build (unit tests).
 */
declare const CORE_OPTIONS: TCoreOptions | undefined;

type TCoreOptionsGlobal = { CORE_OPTIONS?: TCoreOptions };

const NO_OPTIONS: TCoreOptions = Object.freeze({});

// Read once: DefinePlugin inlines CORE_OPTIONS as an object literal, so reading it in getCoreOptions itself would build a
// fresh object graph on every call (hot paths: retries, session reads, every CoreImage render).
const BUILD_OPTIONS = typeof CORE_OPTIONS !== 'undefined' ? CORE_OPTIONS : undefined;

/**
 * The package's core options for this build, or an empty object when there are none. Callers apply their own defaults.
 * Always the same object in an app build. Without a build (unit tests) it reads `globalThis.CORE_OPTIONS` on each call,
 * so a test can set the options per case.
 */
export const getCoreOptions = (): TCoreOptions => BUILD_OPTIONS ?? (globalThis as TCoreOptionsGlobal).CORE_OPTIONS ?? NO_OPTIONS;
